import { consoleRoutes, type PermissionKey } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink, Button, EmptyState, Icon } from "@sagot/ui";
import { useWorkspaceContext } from "../session/workspace-context";
import { RequirePermission } from "./forbidden-page";

function BackHome() {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  return (
    <Button asChild variant="secondary">
      <AppLink href={consoleRoutes.dashboard(summary.slug)}>
        <Icon name="arrow-left" />
        {t("common.backToDashboard")}
      </AppLink>
    </Button>
  );
}

/** Workspace screens arriving in later phases (P6+): permission-gated placeholder. */
export function PlaceholderPage({ titleKey }: { titleKey: string }) {
  const { t } = useTranslation();
  const page = t(titleKey);
  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="text-2xl font-extrabold tracking-tight">{page}</h1>
      <div className="card mt-6">
        <EmptyState icon="layers" title={t("pages.placeholderTitle")} description={t("pages.placeholderBody", { page })} action={<BackHome />} />
      </div>
    </div>
  );
}

export function GatedPlaceholder({ titleKey, permission, mode }: { titleKey: string; permission: PermissionKey; mode?: "workspace" | "anywhere" | "agent" }) {
  return (
    <RequirePermission permission={permission} mode={mode}>
      <PlaceholderPage titleKey={titleKey} />
    </RequirePermission>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="sr-only">{t("pages.notFoundTitle")}</h1>
      <div className="card">
        <EmptyState icon="search" headingLevel={2} title={t("pages.notFoundTitle")} description={t("pages.notFoundBody")} action={<BackHome />} />
      </div>
    </div>
  );
}
